export default "__VITE_ASSET__Brl8uVlg__"